import { render } from "./KiDotNet.vue?vue&type=template&id=07bf3604"
import script from "./KiDotNet.vue?vue&type=script&lang=js"
export * from "./KiDotNet.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__